import { useCallback, useMemo, useState } from 'react'
import _ from 'lodash'


export default function useFilterBy(toFilter, isCategory) {

    const filterElementBy = useCallback((name) => {
        return (project) => {
            return project.category.some((category) => category.name.toLowerCase() === name)
        }
    }, [])



    isCategory = useMemo(() => {
        return isCategory || filterElementBy
    }, [isCategory, filterElementBy])



    const [filter, setFilter] = useState('all')
    const [filtered, setFiltered] = useState(toFilter)

    const filterArray = useCallback((toFilter, name) => {
        if (name === 'all' || name === '') {
            return toFilter
        }
        return _.filter(toFilter, isCategory(name))
    }, [isCategory])

    const filterBy = useCallback((name) => {

        name = name.toLowerCase()
        setFilter(name)
        const filtered = filterArray(toFilter, name)
        setFiltered(filtered)

        return filtered
    }, [filterArray, toFilter])





    return [filtered, filterBy, filter]
}
